export const TECHNIQUES_ACTIONS = {
    GET: 'GET_TECHNIQUES',
    FIND: 'FIND_TECHNIQUES',
    GET_COMBO: 'GET_COMBO_TECHNIQUES',

    GET_STAGES: 'GET_STAGES_TECHNIQUES',
    GET_ALL_STAGES: 'GET_ALL_STAGES_TECHNIQUES',
    GET_ALL_STAGES_LIST: 'GET_ALL_STAGES_TECHNIQUES_LIST',
    FIND_STAGE: 'FIND_STAGE_TECHNIQUES',
    CHANGE_STATUS: 'CHANGE_STATUS_TECHNIQUES',

    SUCCESS: 'SUCCESS_TECHNIQUES',
    ERROR: 'ERROR_TECHNIQUES',
    CLEAN: 'CLEAN_TECHNIQUES',
}